"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDateFilterConfigurationHandling = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = require("react");
var sdk_model_1 = require("@gooddata/sdk-model");
var first_1 = tslib_1.__importDefault(require("lodash/first"));
var model_1 = require("../../../../model");
var safeSerializeObjRef_1 = require("../../../../_staging/metadata/safeSerializeObjRef");
var getRecommendedCatalogDateDataset_1 = require("../../../../_staging/dateDatasets/getRecommendedCatalogDateDataset");
function useDateFilterConfigurationHandling(widget, relatedDateDatasets, onAppliedChanged) {
    var _a = tslib_1.__read(react_1.useState("ok"), 2), status = _a[0], setStatus = _a[1];
    var ref = sdk_model_1.widgetRef(widget);
    var disableKpiDateFilter = model_1.useDashboardCommandProcessing({
        commandCreator: model_1.disableKpiWidgetDateFilter,
        successEvent: "GDC.DASH/EVT.KPI_WIDGET.FILTER_SETTINGS_CHANGED",
        errorEvent: "GDC.DASH/EVT.COMMAND.FAILED",
        onBeforeRun: function () {
            onAppliedChanged(false);
        },
    }).run;
    var enableKpiDateFilter = model_1.useDashboardCommandProcessing({
        commandCreator: model_1.enableKpiWidgetDateFilter,
        successEvent: "GDC.DASH/EVT.KPI_WIDGET.FILTER_SETTINGS_CHANGED",
        errorEvent: "GDC.DASH/EVT.COMMAND.FAILED",
        onBeforeRun: function () {
            onAppliedChanged(true);
            setStatus("loading");
        },
        onError: function () {
            setStatus("error");
        },
        onSuccess: function (_command) {
            setStatus("ok");
        },
    }).run;
    var disableInsightDateFilter = model_1.useDashboardCommandProcessing({
        commandCreator: model_1.disableInsightWidgetDateFilter,
        successEvent: "GDC.DASH/EVT.INSIGHT_WIDGET.FILTER_SETTINGS_CHANGED",
        errorEvent: "GDC.DASH/EVT.COMMAND.FAILED",
        onBeforeRun: function () {
            onAppliedChanged(false);
        },
    }).run;
    var enableInsightDateFilter = model_1.useDashboardCommandProcessing({
        commandCreator: model_1.enableInsightWidgetDateFilter,
        successEvent: "GDC.DASH/EVT.INSIGHT_WIDGET.FILTER_SETTINGS_CHANGED",
        errorEvent: "GDC.DASH/EVT.COMMAND.FAILED",
        onBeforeRun: function () {
            onAppliedChanged(true);
            setStatus("loading");
        },
        onError: function () {
            setStatus("error");
        },
        onSuccess: function (_command) {
            setStatus("ok");
        },
    }).run;
    var handleDateFilterEnabled = react_1.useCallback(function (enabled, dateDatasetRef) {
        var getPreselectedDateDataset = function () {
            if (!(relatedDateDatasets === null || relatedDateDatasets === void 0 ? void 0 : relatedDateDatasets.length)) {
                return null;
            }
            // preselect the recommended if any, or the first one
            var recommendedDateDataSet = getRecommendedCatalogDateDataset_1.getRecommendedCatalogDateDataset(relatedDateDatasets);
            var firstDataSet = first_1.default(relatedDateDatasets);
            return recommendedDateDataSet
                ? recommendedDateDataSet.dataSet.ref
                : firstDataSet.dataSet.ref;
        };
        var enable = sdk_model_1.isInsightWidget(widget) ? enableInsightDateFilter : enableKpiDateFilter;
        var disable = sdk_model_1.isInsightWidget(widget) ? disableInsightDateFilter : disableKpiDateFilter;
        if (enabled) {
            if (dateDatasetRef) {
                enable(ref, dateDatasetRef);
            }
            else {
                var preselectedDateDataSetRef = getPreselectedDateDataset();
                enable(ref, preselectedDateDataSetRef !== null && preselectedDateDataSetRef !== void 0 ? preselectedDateDataSetRef : "default");
            }
        }
        else {
            disable(ref);
        }
    }, [
        sdk_model_1.isInsightWidget(widget),
        safeSerializeObjRef_1.safeSerializeObjRef(ref),
        enableInsightDateFilter,
        disableInsightDateFilter,
        enableKpiDateFilter,
        disableKpiDateFilter,
        relatedDateDatasets,
    ]);
    var handleDateDatasetChanged = react_1.useCallback(function (id) {
        if (sdk_model_1.isInsightWidget(widget)) {
            enableInsightDateFilter(ref, sdk_model_1.idRef(id, "dataSet"));
        }
        else {
            enableKpiDateFilter(ref, sdk_model_1.idRef(id, "dataSet"));
        }
    }, [sdk_model_1.isInsightWidget(widget), safeSerializeObjRef_1.safeSerializeObjRef(ref)]);
    return {
        status: status,
        handleDateDatasetChanged: handleDateDatasetChanged,
        handleDateFilterEnabled: handleDateFilterEnabled,
    };
}
exports.useDateFilterConfigurationHandling = useDateFilterConfigurationHandling;
//# sourceMappingURL=useDateFilterConfigurationHandling.js.map